import React, { useEffect } from 'react';

function OutsideClickListener({ reference, onOutsideClick }) {
  useEffect(() => {
    function handleClickOutside(event) {
      if (reference.current && !reference.current?.contains(event.target)) {
        if (onOutsideClick) onOutsideClick();
      }
    }
    // Bind the event listener
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [reference]);

  return null;
}

export default OutsideClickListener;
